import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import classes from './ClaimPlinkoAnimation.module.scss';
import { ClaimPlinkoRiveAnimation } from './ClaimPlinkoRiveAnimation/ClaimPlinkoRiveAnimation';

function ClaimPlinkoAnimationComponent() {
  const { plinkoStore } = useStores();
  const { claimPlinkoAnimationState } = plinkoStore;

  if (!claimPlinkoAnimationState.enable) {
    return null;
  }

  const animationKey = `${claimPlinkoAnimationState.coinType}-${claimPlinkoAnimationState.plinkoAmount}`;

  return (
    <div className={classes.claimPlinkoAnimation}>
      <ClaimPlinkoRiveAnimation
        key={animationKey}
        amount={claimPlinkoAnimationState.plinkoAmount}
        input={claimPlinkoAnimationState.coinType === 'SC' ? 'green' : 'yellow'}
        onAnimationEnd={() => {
          claimPlinkoAnimationState.onAnimationEnd?.();
        }}
      />
    </div>
  );
}

export const ClaimPlinkoAnimation = observer(ClaimPlinkoAnimationComponent);
